import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import FormatService from "../services/format-service";
import React from "react";
import HelperService from "../services/helper-service";
import _ from "lodash";

export default function MyHighchart({ titleY=null, options, ...props}) {
  const textColor = '#6c757d';
  const defaultOptions = {
    series: [],
    title: {
      text: undefined
    },
    xAxis: {
      type: 'datetime',
      labels: {
        style: {
          color: textColor
        },
        format: '{value:%m/%y}'
      },
      lineColor: textColor,
      tickColor: textColor,
    },
    yAxis: {
      title: {
        text: titleY
      },
      maxPadding: 0.15,
      labels: {
        style: {
          color: textColor
        }
      },
      lineColor: textColor,
      formatter: function() {
        if (this.y > 1000000) {
          return Highcharts.numberFormat(this.y / 1000000, 3) + "M"
        } else if (this.y > 1000) {
          return Highcharts.numberFormat(this.y / 1000, 3) + "K";
        } else {
          return this.y
        }
      }
    },
    credits: {enabled: false},
    accessibility: {enabled: false},
    plotOptions: {
      area: {
        fillOpacity: 1,
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3
          }
        },
        threshold: 0
      }
    },
    legend: {
      itemStyle: {
        color: textColor
      }
    },
    tooltip: {
      useHTML: true,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      shadow: false,
      padding: 0,
      shared: true,
      formatter: function(tooltip){
        const points = this.points;
        let htmlPoints = points.reduce(function (s, point) {
          return `${s}<br/><span style="display: inline-block; width: 12px; height: 12px; background: ${point.series.color}"></span> ${point.series.name}: <strong>${FormatService.formatNumber(point.y)}€</strong>`;
        }, '<b>' + HelperService.getDayjs()(this.x).format('DD. MM. YYYY') + '</b>');
        return `<div style="
					border-radius: 0.5rem 0.5rem 0.5rem 0;
					background-color: white;
					box-shadow: rgba(115,127,237,0.2) 0px 3px 10px 0px;
					padding: 0.5rem;
					line-height: 18px;
				">
					${htmlPoints}
				</div>`;
      },
    },
    chart: {
      height: 400,
      style: {
        fontFamily: 'Nunito, sans-serif',
        color: textColor
      }
    }
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={_.merge(defaultOptions, options)}
    />
  );
}
